var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGatedCommunity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6521 0.834928C23.6882 0.357865 30.1747 2.02758 35.4147 6.54044V35.7336H18.6521V0.834928ZM21.8607 27.3042V32.4942H32.1599V27.3042H21.8607ZM26.4313 5.02461V23.9878H27.6547V5.47474L26.4313 5.02461ZM21.8607 4.09742V23.9763H23.0688V4.18206L21.8607 4.09742ZM30.9672 7.24449V24.0071H32.183V8.06011L30.9672 7.24449Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2287 35.7413H0.485352V6.50196C5.2983 2.52003 10.8422 0.492512 17.2287 0.765669V35.7413ZM3.68245 32.4865H14.0201V27.308H3.68245V32.4865ZM9.49568 24.0225V5.02461L8.23763 5.50552V24.0109L9.49568 24.0225ZM12.8005 4.19359V24.0186H14.0201V4.09356L12.8005 4.19359ZM4.90588 24.0186V7.24448L3.69399 8.06396V24.0071L4.90588 24.0186Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatedCommunity);
export default __webpack_public_path__ + "static/media/gated-community.e1cbab7aac0385a42b9905e5b40d527f.svg";
export { ForwardRef as ReactComponent };